<template>
  <div>
    <!-- ======= Hero Section ======= -->
    <section id="hero" class="d-flex" style="height: 40%">

      <div class="container">
        <div class="row">
          <div class="col-md-10 offset-md-2">
            <div class="card-design">
              <ul class="ul-custom">
                <li class="list-button appointment-b"><a href="appointment.html">Book Appoinment</a></li>
                <li class="list-button doctor-b"><a href="doctors1.html" class="specialdesign"><i
                    class="icofont-minus-circle live-button">লাইভ</i>Live Doctors</a></li>
                <li class="list-button download-b"><a href="doctors1.html">DOWNLOAD APP</a></li>

              </ul>
            </div>
<!--            <div class="card-design">-->
<!--              <ul class="ul-custom">-->
<!--              </ul>-->
<!--            </div>-->
          </div>
        </div>

      </div>

    </section><!-- End Hero -->


    <!-- ======= Services Section ======= -->
    <section id="services1" class="services special-dr-css">
      <div class="container">

        <div class="section-title">
          <h2>Our Specialist Doctors</h2>
        </div>

        <div class="row">
          <div class="offset-md-1 offset-lg-1 col-lg-10 col-md-10">
            <div class="row">
              <!--              <div class="col-lg-2 col-md-2 col-padding">-->
              <!--                <div class="icon-box">-->
              <!--                  <h5 class="center-h5"><a href="">Lorem Ipsum</a></h5>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="col-lg-4 mt-4" v-for="featuredDoctor in featuredDoctors" :key="featuredDoctor.id">
                <div class="icon-box">

                  <div class="member d-flex justify-content-between">
                    <div class="pic" v-if="featuredDoctor.image!==null">
                      <img :src="getImageUrl(featuredDoctor)" height="120" width="120" class="img-fluid" alt="">
                    </div>
                    <div class="pic" v-else>
                      <img src='./../../../../public/assets/img/default_doctor_image.png' height="120" width="120"
                           class="img-fluid" alt="">
                    </div>
                    <div class="member-info">
                      <h5>{{ featuredDoctor.name }}</h5>
                      <span>{{ featuredDoctor.designation }}</span>
                      <p>{{ featuredDoctor.workplace }}</p>

                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </section><!-- End Services Section -->


    <!-- ======= Services Section ======= -->
    <section id="services" class="services socialmedia-css">
      <div class="container">

        <div class="section-title">
          <h2 class="socialmedia-h2">We are in Social Media</h2>
        </div>

        <div class="row">
          <div class="offset-md-1 offset-lg-1 col-lg-10 col-md-10">
            <div class="row">
              <div class="col-lg-4 col-md-4">
                <div class="icon-box media-box">
                  <h2 class="media-box-h2"><a href="">facebook</a></h2>
                </div>
              </div>
              <div class="col-lg-4 col-md-4">
                <div class="icon-box media-box">
                  <h2 class="media-box-h2"><a href="">instagram</a></h2>
                </div>
              </div>
              <div class="col-lg-4 col-md-4">
                <div class="icon-box media-box">
                  <h2 class="media-box-h2"><a href="">facebook</a></h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section><!-- End Services Section -->

    <section id="services2" class="services healthd-css">
      <div class="container">

        <div class="section-title">
          <h2 class="health-h2">Health Directory/Nearby</h2>
        </div>

        <div class="row">
          <div class="offset-md-1 offset-lg-1 col-lg-10 col-md-10">
            <div class="row">
              <div class="col-lg-3 col-md-3">
                <div class="icon-box health-box">
                  <h2 class="health-box-h2"><a href="">Ambulance</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box health-box">
                  <h2 class="health-box-h2"><a href="">Ambulance</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box health-box">
                  <h2 class="health-box-h2"><a href="">Ambulance</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box health-box">
                  <h2 class="health-box-h2"><a href="">Ambulance</a></h2>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </section>

    <section id="services3" class="services ours-ervices-css">
      <div class="container">

        <div class="section-title">
          <h2 class="services-h2">Our Services</h2>
        </div>

        <div class="row">
          <div class="offset-md-1 offset-lg-1 col-lg-10 col-md-10">
            <div class="row">
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">Appoinment</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">Appoinment</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">Appoinment</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">Appoinment</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">Appoinment</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">Doctors</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">ABCD</a></h2>
                </div>
              </div>
              <div class="col-lg-3 col-md-3">
                <div class="icon-box our-services-box">
                  <h2 class="our-services-box-h2"><a href="">EFGH</a></h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>

    <section id="hero2" class="d-flex align-items-center">

      <div class="container">
        <div class="row">
          <div class="col-md-10 offset-md-2">
            <div>
              <h1 class="abcd">Are You a Doctor?</h1>
              <h2 class="defg">We are team of talanted designers making adsja sjdfkjs sjdhfks jsdfhksj websites with
                Bootstrap</h2>
            </div>
            <div class="card-design">
              <ul class="ul-custom">
                <li class="list-button appointment-b">
                  <router-link :to="{name: 'doctorLogin'}">Login/Signup</router-link>
                </li>
                <li class="list-button download-b"><a href="doctors1.html">DOWNLOAD APP</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </section>


    <!-- ======= Footer ======= -->
  </div>
</template>


<script>
import {mapGetters} from 'vuex';
import DoctorService from '@/services/general_user/doctor.service';

export default {
  name: "Home",
  data() {
    return {
      featuredDoctors: [],
    };
  },
  computed: {
    ...mapGetters('generalUserDoctor', ['getdoctortype']),
  },
  methods: {
    getImageUrl(doctor) {
      return `${process.env.VUE_APP_BACKEND_URL}/${doctor.image}`;
    },
    loadFeaturedDoctors() {
      DoctorService.fetchFeaturedDoctors()
          .then((response) => {
            if (response.status === 200) {
              this.featuredDoctors = response.data;
            }
          })
    },
  },
  mounted() {
    this.loadFeaturedDoctors();
  }
}
</script>

<style scoped>
.imgae {
  height: 125px;
  width: 125px;
  margin: 0 auto;
  border-radius: 5px;
  transition: all .3s ease-out 0s;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transform-style: preserve-3d;
}

.icon-box .icon {

}

.heading {
  alignment: center;
}


</style>
